import { render, staticRenderFns } from "./TotalOutputs.vue?vue&type=template&id=1bb6fc42&"
import script from "./TotalOutputs.vue?vue&type=script&lang=js&"
export * from "./TotalOutputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports